import threeFourTwoOne from '../assets/formations/3-4-2-1.png';
import threeFourThree from '../assets/formations/3-4-3.png';
import fourFourTwo from '../assets/formations/4-4-2.png';
import fourThreeThree from '../assets/formations/4-3-3.png';
import fourTwoThreeOne from '../assets/formations/4-2-3-1.png';
import fiveThreeTwo from '../assets/formations/5-3-2.png';
import fiveFourOne from '../assets/formations/5-4-1.png';
import threeFiveTwo from '../assets/formations/3-5-2.png';
import fallbackImage from '../assets/graphics/fallback-player-and-formations.svg';

/**
 * Map of formation names to their corresponding local placeholder images.
 * Used as a fallback when external images fail to load.
 *
 * @type {{[key: string]: string}}
 */
export const FORMATION_PLACEHOLDER_MAP = {
    '3-4-2-1': threeFourTwoOne,
    '3-4-3': threeFourThree,
    '4-4-2': fourFourTwo,
    '4-3-3': fourThreeThree,
    '4-2-3-1': fourTwoThreeOne,
    '5-3-2': fiveThreeTwo,
    '5-4-1': fiveFourOne,
    '3-5-2': threeFiveTwo
};

/**
 * Gets the appropriate image URL for a formation, with fallback handling.
 *
 * @param {object} formation - The formation object
 * @param {string} formation.name - The name of the formation (e.g., "4-4-2")
 * @param {string} [formation.external_image_url] - Optional external image URL
 * @returns {string} The URL to use for the formation image
 */
export const getFormationImage = (formation) => {
    return (
        formation.external_image_url ||
        FORMATION_PLACEHOLDER_MAP[formation.name] ||
        fallbackImage
    );
};

/**
 * Handles image loading errors for formation images with a two-step fallback process.
 * First tries to use a local placeholder image specific to the formation,
 * then falls back to a generic formation image if that fails.
 *
 * @param {Event} event - The error event from the img element
 * @param {object} formation - The formation object
 * @param {string} formation.name - The name of the formation (e.g., "4-4-2")
 */
export const handleFormationImageError = (event, formation) => {
    // If we have a placeholder for this formation, try that first
    const placeholder = FORMATION_PLACEHOLDER_MAP[formation.name];
    if (placeholder && event.target.src !== placeholder) {
        event.target.src = placeholder;
    } else {
        // If we don't have a placeholder or if the placeholder failed, use fallback
        event.target.src = fallbackImage;
    }
};
